<template>
  <v-dialog v-model="showModal" fullscreen persistent>
    <v-card>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="showModal = false" dark>
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-form :class="visibility_class" @submit="handleSubmit">
          <v-tabs grow v-model="active_tab" slider-color="primary">
            <v-tab ripple key="0">Ogólne</v-tab>
            <v-tab ripple key="1">Adres</v-tab>
            <v-tab ripple key="2">Zgody</v-tab>
            <v-tab ripple key="3" v-show="id && id > 0">Historia wizyt</v-tab>
            <v-tab ripple key="4" v-show="id && id > 0 && $can('do', 'POKO_Klienci_Choroby')">Alergie</v-tab>
            <v-tab ripple key="5" v-show="id && id > 0 && $can('do', 'POKO_Klienci_Choroby')">Choroby </v-tab>
            <v-tab ripple key="6"
              v-show="id && id > 0 && isAttachementsEnabled && $can('do', 'POKO_Klienci_Zalaczniki_Przegladanie')">Załączniki</v-tab>
            <v-tab ripple key="7" v-show="id && id > 0 && $can('do', 'POKO_KlienciKredyty') && kredyt">Kredyt </v-tab>
            <v-tab ripple key="8" v-show="id && id > 0 && $can('do', 'POKO_KlienciProblemy')">Problemy</v-tab>
            <v-tab ripple key="9" v-show="id && id > 0 && $can('do', 'POKO_Vouchery')">Vouchery</v-tab>
            <v-tab ripple key="10" v-show="id && id > 0 && $can('do', 'POKO_Klienci_Historia_SMS')">Historia SMS</v-tab>
            <v-tab ripple key="11" v-show="id && id > 0 && $can('do', 'POKO_PlanyZdrowienia')">Plany terapii i
              zdrowienia</v-tab>
            <v-tab ripple key="12" v-show="id && id > 0 && $can('do', 'POKO_Podpisy')">Podpisy</v-tab>
            <v-tab-item key="0">
              <v-card flat>
                <v-card-text>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="6">
                        <v-text-field label="Imię*" v-validate="'required'" name="name" id="name" data-vv-as="Imię"
                          :error-messages="errors.collect('name')" v-model="name"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field label="Nazwisko*" v-validate="'required'" name="surname" id="surname"
                          :error-messages="errors.collect('surname')" data-vv-as="Nazwisko"
                          v-model="surname"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <v-text-field label="Adres email" name="emailAddress" id="emailAddress"
                          v-model="emailAddress"></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field label="Telefon" v-validate="{ regex: /^[0-9\+]{8,13}$/ }" name="phone" id="phone"
                          :error-messages="errors.collect('phone')" data-vv-as="Telefon" v-model="phone"></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-checkbox name="for_sms" id="for_sms" v-model="phoneForSms" label="Do smsów?"></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <v-text-field label="Numer PESEL" name="PESEL" id="PESEL" data-vv-as="Numer PESEL"
                          v-validate="{ regex: /^[0-9]{11}$/ }" :error-messages="errors.collect('PESEL')"
                          :rules="[value => validatePesel(value) || 'Niepoprawny numer PESEL']"
                          v-model="PESEL"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-select :items="genders" clearable label="Płeć" placeholder="Wybierz płeć.." v-model="gender"
                          name="gender" id="gender">
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <v-text-field label="NIP" name="NIP" id="NIP" data-vv-as="Numer NIP"
                          v-validate="{ regex: /^[0-9A-Z\-]*$/ }" v-mask="nip_mask"
                          :error-messages="errors.collect('NIP')" v-model="NIP"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-select :items="therapists" item-text="name" item-value="id" clearable label="Terapeuta"
                          placeholder="Wybierz terapeute.." v-model="therapist" name="therapist" id="therapist">
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <v-text-field label="Krótki opis" v-model="description"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-select :items="knowledesources" clearable label="Skąd o nas wie" placeholder="Nieznane"
                          v-model="knowledge_of_us" name="knowledge_of_us" id="knowledge_of_us">
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row v-if="isPayuEnabled">
                      <v-col cols="12">
                        <v-checkbox label="Płaci z PayU" v-model="PayByPayU"></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <v-text-field label="Data urodzenia"
                          :value="birthDate ? birthDate.toLocaleDateString() : 'Nieznana'" readonly></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field label="Wiek" :value="age !== null ? age + ' lat' : 'Nieznany'"
                          readonly></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-textarea name="notes" label="Uwagi" outline v-model="notes" id="notes"></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="1">
              <v-card flat>
                <v-card-text>
                  <v-container grid-list-xl>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-row>
                          <v-col cols="6">
                            <v-text-field label="Ulica" name="street" id="street" v-model="street"></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-text-field v-model="numer_budynku" label="Nr. budynku"></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-text-field v-model="numer_lokalu" label="Nr. lokalu"></v-text-field>
                          </v-col>
                        </v-row>

                      </v-flex>
                      <v-flex d-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs6>
                            <v-text-field label="Kod pocztowy" name="postcode" id="postcode"
                              v-model="postcode"></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field label="Miasto" name="city" id="city" v-model="city"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-select :items="regions" clearable label="Województwo" placeholder="Wybierz.."
                          v-model="region" name="region" id="region">
                        </v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="2">
              <v-card flat>
                <v-card-text>
                  <v-container grid-list-xl>
                    <v-row no-gutters>
                      <v-col cols="12">
                        <v-container>
                          <v-row no-gutters>
                            <v-col cols="6">
                              <v-checkbox name="have_representative" id="have_representative"
                                v-model="have_representative" label="Ma opiekuna"></v-checkbox>
                            </v-col>
                            <v-col cols="6">
                              <v-container>
                                <v-row no-gutters>
                                  <v-col cols="10">
                                    <v-autocomplete v-model="representativeID" id="representativeID"
                                      name="representativeID" :loading="isLoadingRepresenatives"
                                      :items="representativeList" :search-input.sync="representativeKeyword" cache-items
                                      flat clearable no-data-text="Nieznaleziono" hide-details
                                      v-show="have_representative" item-text="name" item-value="id"
                                      prepend-icon="fa-search"
                                      label="Wyszukaj opiekuna Imię/Nazwisko/PESEL"></v-autocomplete>
                                  </v-col>
                                  <v-col cols="2">
                                    <v-btn v-show="have_representative && representativeID > 0" fab dark small
                                      color="primary" title="Pokaż szczegóły" @click="showRepresentativeDetails">
                                      <v-icon small title="Pokaż szczegóły">fa-info</v-icon>
                                    </v-btn>
                                    <v-btn fab small color="primary" @click="addQuickClientDialog = true"
                                      v-show="have_representative && !representativeID"
                                      v-if="$can('do', 'POKO_Klienci_Edycja')">
                                      <v-icon>fa-plus</v-icon>
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-col>
                          </v-row>
                          <v-row no-gutters
                            v-if="have_representative && $can('do', 'POKO_Klienci_Zalaczniki_Przegladanie')">
                            <v-col cols="3">
                              <v-text-field readonly dense :value="zgodaOpiekunaPrawnegoDescription">
                                <template slot="append-outer">
                                  <v-icon color="primary" class="mr-2" @click="upload(5)"
                                    v-if="enableUploadZgodaOpiekunaPrawnego && $can('do', 'POKO_Klienci_Zalaczniki_Dodawanie')"
                                    title="Wgraj zgodę">fa-upload</v-icon>
                                  <v-icon color="success" class="mr-2"
                                    @click="download(zgodaOpiekunaPrawnego.fingerprint)" v-if="zgodaOpiekunaPrawnego"
                                    title="Pobierz zgodę">fa-download</v-icon>
                                  <v-icon color="primary" title="Generuj zgodę" @click="generateagreetemplate(5)"
                                    v-if="id > 0 && agreeTemplates.find(x => x.type == 5)">fa-cog</v-icon>
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="12">
                        <v-container>
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-checkbox name="agree_receive_sms" id="agree_receive_sms" v-model="agree_receive_sms"
                                label="Zgadza się na otrzymywanie smsów o wizytach"></v-checkbox>
                            </v-col>
                          </v-row>
                          <v-row no-gutters v-if="agree_receive_sms">
                            <v-col cols="3">
                              <v-text-field readonly dense :value="zgodaSmsEmailDescription">
                                <template slot="append-outer">
                                  <v-icon color="primary" class="mr-2" @click="upload(3)"
                                    v-if="enableUploadZgodaSmsEmail && $can('do', 'POKO_Klienci_Zalaczniki_Dodawanie')"
                                    title="Wgraj zgodę">fa-upload</v-icon>
                                  <v-icon color="success" class="mr-2" @click="download(zgodaSmsEmail.fingerprint)"
                                    v-if="zgodaSmsEmail" title="Pobierz zgodę">fa-download</v-icon>
                                  <v-icon color="primary" title="Generuj zgodę" @click="generateagreetemplate(3)"
                                    v-if="id > 0 && agreeTemplates.find(x => x.type == 3)">fa-cog</v-icon>
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="12">
                        <v-container>
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-checkbox name="confirm_sms" id="confirm_sms" v-model="confirm_sms"
                                label="Potwierdza wizyty przez SMS"></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="12">
                        <v-container>
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-checkbox name="refuse_receive_email" id="refuse_receive_email"
                                v-model="refuse_receive_email"
                                label="Nie chce otrzymywać maili o wizytach"></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-container>

                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="12">
                        <v-container>
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-checkbox name="agree_process_data" id="agree_process_data" v-model="agree_process_data"
                                label="Zgadza się na przetwarzanie swoich danych osobowych"></v-checkbox>
                            </v-col>
                          </v-row>
                          <v-row no-gutters v-if="agree_process_data">
                            <v-col cols="3">
                              <v-text-field readonly dense :value="processDataDescription">
                                <template slot="append-outer">
                                  <v-icon color="primary" class="mr-2" @click="upload(1)"
                                    v-if="enableUploadProcessData && $can('do', 'POKO_Klienci_Zalaczniki_Dodawanie')"
                                    title="Wgraj zgodę">fa-upload</v-icon>
                                  <v-icon color="success" class="mr-2" @click="download(processData.fingerprint)"
                                    v-if="processData" title="Pobierz zgodę">fa-download</v-icon>
                                  <v-icon color="primary" title="Generuj zgodę" @click="generateagreetemplate(1)"
                                    v-if="id > 0 && agreeTemplates.find(x => x.type == 1)">fa-cog</v-icon>
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="12">
                        <v-container>
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-checkbox v-model="agree_for_health_services"
                                label="Zgoda na udzielanie świadczeń zdrowotnych"></v-checkbox>
                            </v-col>
                          </v-row>
                          <v-row no-gutters v-if="agree_for_health_services">
                            <v-col cols="3">
                              <v-text-field readonly dense :value="healthServicesDescription">
                                <template slot="append-outer">
                                  <v-icon color="primary" class="mr-2" @click="upload(2)"
                                    v-if="enableUploadHealthServices && $can('do', 'POKO_Klienci_Zalaczniki_Dodawanie')"
                                    title="Wgraj zgodę">fa-upload</v-icon>
                                  <v-icon color="success" class="mr-2" @click="download(healthServices.fingerprint)"
                                    v-if="healthServices" title="Pobierz zgodę">fa-download</v-icon>
                                  <v-icon color="primary" title="Generuj zgodę" @click="generateagreetemplate(2)"
                                    v-if="id > 0 && agreeTemplates.find(x => x.type == 2)">fa-cog</v-icon>
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="12">
                        <v-container>
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-checkbox name="covidQuestionnaire" id="covidQuestionnaire" v-model="covidQuestionnaire"
                                label="Ankieta covid"></v-checkbox>
                            </v-col>
                          </v-row>
                          <v-row no-gutters v-if="covidQuestionnaire">
                            <v-col cols="3">
                              <v-text-field readonly dense :value="covidQuestionnaireAttachmentDescription">
                                <template slot="append-outer">
                                  <v-icon color="primary" class="mr-2" @click="upload(4)"
                                    v-if="enableUploadCovidQuestionnaireAttachment && $can('do', 'POKO_Klienci_Zalaczniki_Dodawanie')"
                                    title="Wgraj ankiete">fa-upload</v-icon>
                                  <v-icon color="success" class="mr-2"
                                    @click="download(covidQuestionnaireAttachment.fingerprint)"
                                    v-if="covidQuestionnaireAttachment" title="Pobierz ankiete">fa-download</v-icon>
                                  <v-icon color="primary" title="Generuj zgodę" @click="generateagreetemplate(4)"
                                    v-if="id > 0 && agreeTemplates.find(x => x.type == 4)">fa-cog</v-icon>
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="12">
                        <v-container>
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-checkbox name="agree_for_commercial" id="agree_for_commercial"
                                v-model="agree_for_commercial" label="Zgoda na informacje handlowe"></v-checkbox>
                            </v-col>
                          </v-row>
                          <v-row no-gutters v-if="agree_for_commercial">
                            <v-col cols="3">
                              <v-text-field readonly dense :value="commercialInformationDescription">
                                <template slot="append-outer">
                                  <v-icon color="primary" class="mr-2" @click="upload(6)"
                                    v-if="enableUploadCommercialInformation && $can('do', 'POKO_Klienci_Zalaczniki_Dodawanie')"
                                    title="Wgraj zgodę">fa-upload</v-icon>
                                  <v-icon color="success" class="mr-2"
                                    @click="download(commercialInformation.fingerprint)" v-if="commercialInformation"
                                    title="Pobierz zgodę">fa-download</v-icon>
                                  <v-icon color="primary" title="Generuj zgodę" @click="generateagreetemplate(6)"
                                    v-if="id > 0 && agreeTemplates.find(x => x.type == 6)">fa-cog</v-icon>
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-col>
                    </v-row>
                    <v-row no-gutters v-show="$can('do', 'POKO_KlienciKredyty')">
                      <v-col cols="12">
                        <v-container>
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-checkbox name="kredyt" id="kredyt" v-model="kredyt" label="Kredyt">
                              </v-checkbox>
                            </v-col>
                          </v-row>
                          <v-row v-if="kredyt">
                            <v-col cols="6">
                              <v-select v-model="wybrana_podstawa" :items="podstawy_kredytu"></v-select>
                            </v-col>
                            <v-col cols="6" v-if="wybrana_podstawa == 'Inne'">
                              <v-text-field label="Inna podstawa" v-model="inna_podstawa_kredytu"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row v-if="kredyt">
                            <v-col cols="6">
                              <v-text-field label="Limit kredytu" min="0" v-model.number="limit_kredytowy" step="0.01"
                                type="number">
                                >
                              </v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-menu v-model="open_date_kredyt" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field v-model="waznosc_kredytu" label="Ważność kredytu"
                                    prepend-icon="fa-calendar-alt" readonly clearable v-bind="attrs"
                                    v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="waznosc_kredytu"
                                  @input="open_date_kredyt = false"></v-date-picker>
                              </v-menu>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="3" v-show="id && id > 0">
              <v-card flat>
                <v-card-text>
                  <MedicalVisitHistory :clientid="id" v-if="active_tab == 3"></MedicalVisitHistory>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="4" v-show="id && id > 0 && $can('do', 'POKO_Klienci_Choroby')">
              <v-card flat>
                <v-card-text>
                  <ClientDiseasesICD :clientid="id" :hideedit="false" :type="1" v-if="active_tab == 4">
                  </ClientDiseasesICD>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="5" v-show="id && id > 0 && $can('do', 'POKO_Klienci_Choroby')">
              <v-card flat>
                <v-card-text>
                  <ClientDiseasesICD :clientid="id" :hideedit="false" :type="0" v-if="active_tab == 5">
                  </ClientDiseasesICD>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="6"
              v-show="id && id > 0 && isAttachementsEnabled && $can('do', 'POKO_Klienci_Zalaczniki_Przegladanie')">
              <v-card flat>
                <v-card-text>
                  <ClientAttachments :client="id" v-if="active_tab == 6"></ClientAttachments>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="7" v-show="id && id > 0 && $can('do', 'POKO_KlienciKredyty') && kredyt">
              <Kredyt :clientid="id" v-if="active_tab == 7"></Kredyt>
            </v-tab-item>
            <v-tab-item key="8" v-show="id && id > 0 && $can('do', 'POKO_KlienciProblemy')">
              <Problemy :clientid="id" v-if="active_tab == 8"></Problemy>
            </v-tab-item>
            <v-tab-item key="9" v-show="id && id > 0 && $can('do', 'POKO_Vouchery')">
              <v-card flat>
                <v-card-text>
                  <VoucheryKlienta :clientid="id" v-if="active_tab == 9"></VoucheryKlienta>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="10" v-show="id && id > 0 && $can('do', 'POKO_Klienci_Historia_SMS')">
              <v-card flat>
                <v-card-text>
                  <ClientSMS :clientid="id" v-if="active_tab == 10"></ClientSMS>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="11" v-show="id && id > 0 && $can('do', 'POKO_PlanyZdrowienia')">
              <v-card flat>
                <v-card-text>
                  <PlanyZdrowienia :clientid="id" v-if="active_tab == 11"></PlanyZdrowienia>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="12" v-show="id && id > 0 && $can('do', 'POKO_Podpisy')">
              <v-card flat>
                <v-card-text>
                  <ClientSignatures :client="id" :clientName="(name || '') + ' ' + (surname || '')" v-if="active_tab == 12"></ClientSignatures>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>


        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeForm" color="error">Zamknij</v-btn>
        <v-btn color="success" @click="handleSubmit">Zapisz</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="showRepresentativeDialog" max-width="600px">
      <ClientDetailsReadOnly :details="representativeDetails" v-if="showRepresentativeDialog"
        @close="showRepresentativeDialog = false" />
    </v-dialog>

    <v-dialog v-model="addQuickClientDialog" max-width="500px" v-if="$can('do', 'POKO_Klienci_Edycja')">
      <QuickAddClient v-if="addQuickClientDialog" :addressdetails="addressdetails" @close="addQuickClientDialog = false"
        @success="successSaveNewRepresentative" title="Dodawanie nowego opiekuna"></QuickAddClient>
    </v-dialog>
    <v-dialog v-model="showUploadAttachment" width="768">
      <AddAttachment :client="id" v-if="showUploadAttachment" :description="selectedFileDescription"
        @close="showUploadAttachment = false" @uploaded="uploadedDone"></AddAttachment>
    </v-dialog>
  </v-dialog>
</template>

<script>
import { clientService } from "@/services/";
import { userService } from "@/services/";
import swal from "sweetalert";
import ClientDetailsReadOnly from "./ClientDetailsReadOnly";
import { mask } from 'vue-the-mask'
import QuickAddClient from "./QuickAddClient";
import MedicalVisitHistory from "./MedicalVisitHistory";
import ClientDiseasesICD from "./ClientDiseasesICD";
import { mapState } from "vuex";
import ClientAttachments from "@/components/clients/ClientAttachments";
import AddAttachment from "@/components/clients/AddAttachment";
import { settingsService } from "@/services";
import dayjs from "dayjs";
import Kredyt from "@/components/clients/Kredyt";
import Problemy from "@/components/clients/Problemy";
import VoucheryKlienta from "@/components/clients/VoucheryKlienta";
import ClientSMS from "@/components/clients/ClientSMS";
import PlanyZdrowienia from "@/components/clients/PlanyZdrowienia.vue";
import ClientSignatures from "@/components/clients/ClientSignatures.vue";
export default {
  name: 'AddEditClient',
  directives: {
    mask
  },
  components: {
    ClientSignatures,
    PlanyZdrowienia,
    ClientSMS,
    VoucheryKlienta,
    Problemy,
    Kredyt,
    AddAttachment,
    ClientAttachments, ClientDiseasesICD, MedicalVisitHistory, QuickAddClient, ClientDetailsReadOnly
  },
  data() {
    return {
      title: "Dodawanie nowego pacjenta",
      loading: false,
      name: null,
      surname: null,
      phone: null,
      phoneForSms: false,
      gender: -1,
      PESEL: null,
      emailAddress: null,
      therapist: 0,
      therapists: [],
      knowledge_of_us: '',
      initialized: false,
      notes: null,
      street: null,
      postcode: null,
      city: null,
      nip_mask: '###-###-##-##',
      region: '',
      numer_budynku: '',
      numer_lokalu: '',
      representativeID: null,
      isLoadingRepresenatives: false,
      representativeList: [],
      representativeKeyword: null,
      have_representative: false,
      representative_data: null,
      agree_receive_sms: true,
      confirm_sms: true,
      refuse_receive_email: false,
      agree_process_data: false,
      agree_for_health_services: true,
      agree_for_commercial: false,
      visibility_class: 'row',
      saving: false,
      active_tab: 0,
      showRepresentativeDialog: false,
      representativeDetails: null,
      NIP: null,
      genders: [
        { value: 0, text: "Mężczyzna" },
        { value: 1, text: "Kobieta" },
      ],
      knowledesources: [
        { value: "internet", text: "Internet" },
        { value: "z_polecenia", text: "Z polecenia" },
        { value: "od_lekarza", text: "Od innego lekarza" },
        { value: "z_prasy", text: "Z prasy" },
        { value: "byly_pacjent", text: "Były pacjent" },
      ],
      regions: [
        { value: "dolnośląskie", text: "dolnośląskie" },
        { value: "kujawsko-pomorskie", text: "kujawsko-pomorskie" },
        { value: "lubelskie", text: "lubelskie" },
        { value: "lubuskie", text: "lubuskie" },
        { value: "łódzkie", text: "łódzkie" },
        { value: "małopolskie", text: "małopolskie" },
        { value: "mazowieckie", text: "mazowieckie" },
        { value: "opolskie", text: "opolskie" },
        { value: "podkarpackie", text: "podkarpackie" },
        { value: "podlaskie", text: "podlaskie" },
        { value: "pomorskie", text: "pomorskie" },
        { value: "śląskie", text: "śląskie" },
        { value: "świętokrzyskie", text: "świętokrzyskie" },
        { value: "warmińsko-mazurskie", text: "warmińsko-mazurskie" },
        { value: "wielkopolskie", text: "wielkopolskie" },
        { value: "zachoniopomorskie", text: "zachoniopomorskie" }
      ],
      addQuickClientDialog: false,
      addressdetails: null,
      fileDescriptions: [],
      attachments: [],
      selectedFileDescription: null,
      showUploadAttachment: false,
      zgodaOpiekunaPrawnego: null,
      enableUploadZgodaOpiekunaPrawnego: false,
      zgodaSmsEmail: null,
      enableUploadZgodaSmsEmail: false,
      processData: null,
      enableUploadProcessData: false,
      healthServices: null,
      enableUploadHealthServices: false,
      commercialInformation: null,
      enableUploadCommercialInformation: false,
      covidQuestionnaire: false,
      enableUploadCovidQuestionnaireAttachment: false,
      covidQuestionnaireAttachment: null,
      agreeTemplates: [],
      kredyt: false,
      kredyt_podstawa: '',
      limit_kredytowy: 0,
      waznosc_kredytu: null,
      podstawy_kredytu: ['Umowa podmiot prywatny', 'Umowa podmiot publiczny', 'Umowa fundacja', 'Umowa ubezpieczyciel', 'Decyzja dyrekcji', 'Inne'],
      wybrana_podstawa: '',
      inna_podstawa_kredytu: '',
      open_date_kredyt: false,
      description: null,
      PayByPayU: false,
      birthDate: null,
      age: null,
    }
  },
  props: ["id", "visible"],
  methods: {
    calculateBirthDateAndAge(pesel) {
      if (!/^\d{11}$/.test(pesel)) {
        this.birthDate = null;
        this.age = null;
        return;
      }

      const yearBase = parseInt(pesel.substring(0, 2), 10);
      const month = parseInt(pesel.substring(2, 4), 10);
      const day = parseInt(pesel.substring(4, 6), 10);

      let year;
      if (month > 80) {
        year = 1800 + yearBase;
      } else if (month > 60) {
        year = 2200 + yearBase;
      } else if (month > 40) {
        year = 2100 + yearBase;
      } else if (month > 20) {
        year = 2000 + yearBase;
      } else {
        year = 1900 + yearBase;
      }

      const correctedMonth = month % 20; // Usunięcie przesunięcia wieku
      this.birthDate = new Date(year, correctedMonth - 1, day);

      const today = new Date();
      this.age = today.getFullYear() - year;
      if (
        today.getMonth() < correctedMonth - 1 ||
        (today.getMonth() === correctedMonth - 1 && today.getDate() < day)
      ) {
        this.age--;
      }
    },
    setGenderFromPesel(pesel) {
      if (/^\d{11}$/.test(pesel)) {
        const genderDigit = parseInt(pesel[9], 10); // 10. cyfra PESEL
        this.gender = genderDigit % 2 === 0 ? 1 : 0; // 1 = Kobieta, 0 = Mężczyzna
      } else {
        this.gender = -1; // Resetuj płeć, jeśli PESEL jest niepoprawny
      }
    },
    validatePesel(pesel) {
      if (!pesel)
        return true;
      if (!/^\d{11}$/.test(pesel)) {
        return false; // PESEL musi składać się z 11 cyfr
      }

      const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
      const digits = pesel.split('').map(Number);
      const checksum = digits.slice(0, 10).reduce((sum, digit, index) => sum + digit * weights[index], 0);
      const controlDigit = (10 - (checksum % 10)) % 10;

      return controlDigit === digits[10];
    },
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
    uploadedDone() {
      this.showUploadAttachment = false
      this.getAttachments()
    },
    hide() {
      this.visibility_class = 'row scale-transition scale-out'
      this.loading = true
    },
    show() {
      this.visibility_class = 'row'
      this.loading = false
    },
    closeForm() {
      this.$emit("close");
    },
    upload(type) {
      this.selectedFileDescription = this.fileDescriptions.find(x => x.type == type)
      this.showUploadAttachment = true
    },
    download(fingerprint) {
      clientService.preDownloadAttachment(fingerprint).then((response) => {
        let pokoFile = response.data.result
        clientService.downloadAttachment(pokoFile.token).then((resp) => {
          if (resp.data != null) {
            this.fileDownload(resp.data, pokoFile.file_name, pokoFile.mime_type)
          }
          else {
            throw 'error'
          }
        }).catch(() => {
          this.showError('Błąd pobierania załącznika')
        })
      }).catch(() => {
        this.showError('Błąd pobierania załącznika')
      })
    },
    fileDownload(data, filename, mime) {
      var blob = new Blob([data], { type: mime || 'application/octet-stream' });
      if (typeof window.navigator.msSaveBlob !== 'undefined') {
        window.navigator.msSaveBlob(blob, filename);
      }
      else {
        var blobURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', filename);

        if (typeof tempLink.download === 'undefined') {
          tempLink.setAttribute('target', '_blank');
        }

        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobURL);
      }
    },
    test() {

    },
    clearFormData() {

      this.active_tab = 0
      this.title = "Dodawanie nowego pacjenta"
      this.loading = false
      this.name = null
      this.surname = null
      this.phone = null
      this.phoneForSms = false
      this.gender = -1
      this.PESEL = null
      this.emailAddress = null
      this.therapist = 0
      this.knowledge_of_us = null
      this.notes = null
      this.street = null
      this.postcode = null
      this.city = null
      this.region = null
      this.have_representative = false
      this.representative_data = null
      this.agree_receive_sms = true
      this.confirm_sms = true
      this.refuse_receive_email = false
      this.agree_for_commercial = false
      this.agree_process_data = false
      this.agree_for_health_services = true
      this.visibility_class = 'row'
      this.saving = false
      this.representativeID = null
      this.representativeList = []
      this.active_tab = 0
      this.NIP = null
      this.covidQuestionnaire = false
      this.kredyt = false
      this.kredyt_podstawa = ''
      this.limit_kredytowy = 0
      this.waznosc_kredytu = null
      this.wybrana_podstawa = ''
      this.inna_podstawa_kredytu = ''
      this.open_date_kredyt = false
      this.description = null
      this.numer_lokalu = ''
      this.numer_budynku = ''
      this.PayByPayU = false
    },
    handleSubmit() {
      //this.active_tab = 0

      if (this.kredyt && this.wybrana_podstawa == 'Inna' && (!this.inna_podstawa_kredytu || this.inna_podstawa_kredytu == '')) {
        this.showError(false, 'Nie podano innej podstawy kredytu')
        return
      }

      if (this.kredyt && (!this.wybrana_podstawa || this.wybrana_podstawa == '')) {
        this.showError(false, 'Nie podano podstawy kredytu')
        return
      }

      this.kredyt_podstawa = this.wybrana_podstawa
      if (this.wybrana_podstawa == 'Inne')
        this.kredyt_podstawa = this.inna_podstawa_kredytu

      this.$validator.validate().then(valid => {
        if (valid) {
          if (this.id == 0) {
            this.saveClient()
          }
          else {
            this.updateClient()
          }
        }
      });
    },
    updateClient() {
      this.hide()
      clientService.update({
        id: this.id,
        name: this.name,
        surname: this.surname,
        phone: this.phone,
        usePhoneForSMS: this.phoneForSms,
        emailAddress: this.emailAddress,
        pesel: this.PESEL,
        gender: this.gender,
        notes: this.notes,
        street: this.street,
        postcode: this.postcode,
        city: this.city,
        region: this.region,
        haveRepresentative: this.have_representative,
        representativeData: this.representative_data,
        patientAgreeToReceiveSMS: this.agree_receive_sms,
        patientConfirmVisitsBySMS: this.confirm_sms,
        patientRefuseReceivingEmails: this.refuse_receive_email,
        patientAgreeToProcessHisData: this.agree_process_data,
        agreeForCommercialInformations: this.agree_for_commercial,
        agreeForHealthServices: this.agree_for_health_services,
        covidQuestionnaire: this.covidQuestionnaire,
        therapistID: this.therapist,
        knowledgeOfUsSource: this.knowledge_of_us,
        representativeID: this.representativeID ? this.representativeID : 0,
        nip: this.NIP ? this.NIP.replace('-', '') : null,
        kredyt: this.kredyt,
        kredyt_podstawa: this.kredyt_podstawa,
        limit_kredytowy: this.limit_kredytowy,
        waznosc_kredytu: this.waznosc_kredytu,
        description: this.description,
        numer_budynku: this.numer_budynku,
        numer_lokalu: this.numer_lokalu,
        payByPayU: this.PayByPayU
      }).then(() => {
        this.show()
        this.closeForm()
      }).catch(resp => {
        if (resp.response != null && resp.response.data != null && resp.response.data.error != null) {
          this.showError(false, resp.response.data.error.message)
        }
        else {
          this.showError(false, 'Błąd zapisu pacjenta')
        }
      })
    },
    saveClient() {
      this.hide()
      clientService.create({
        name: this.name,
        surname: this.surname,
        phone: this.phone,
        usePhoneForSMS: this.phoneForSms,
        emailAddress: this.emailAddress,
        pesel: this.PESEL,
        gender: this.gender,
        notes: this.notes,
        street: this.street,
        postcode: this.postcode,
        city: this.city,
        region: this.region,
        haveRepresentative: this.have_representative,
        representativeData: this.representative_data,
        patientAgreeToReceiveSMS: this.agree_receive_sms,
        patientConfirmVisitsBySMS: this.confirm_sms,
        patientRefuseReceivingEmails: this.refuse_receive_email,
        patientAgreeToProcessHisData: this.agree_process_data,
        agreeForCommercialInformations: this.agree_for_commercial,
        agreeForHealthServices: this.agree_for_health_services,
        covidQuestionnaire: this.covidQuestionnaire,
        therapistID: this.therapist,
        representativeID: this.representativeID ? this.representativeID : 0,
        knowledgeOfUsSource: this.knowledge_of_us,
        nip: this.NIP ? this.NIP.replace('-', '') : null,
        kredyt: this.kredyt,
        kredyt_podstawa: this.kredyt_podstawa,
        limit_kredytowy: this.limit_kredytowy,
        waznosc_kredytu: this.waznosc_kredytu,
        description: this.description,
        numer_budynku: this.numer_budynku,
        numer_lokalu: this.numer_lokalu,
        payByPayU: this.PayByPayU
      }).then(() => {
        this.show()
        this.closeForm()
      }).catch(resp => {
        if (resp.response != null && resp.response.data != null && resp.response.data.error != null) {
          this.showError(false, resp.response.data.error.message)
        }
        else {
          this.showError(false, 'Błąd zapisu pacjenta')
        }
      })
    },
    loadClientData() {
      this.loading = true;

      clientService.get(this.id).then(resp => {
        if (resp.data != null && resp.data.success && resp.data.result != null) {

          var client = resp.data.result;
          this.title = "Dane pacjenta: " + client.name + ' ' + client.surname
          this.name = client.name
          this.surname = client.surname
          this.phone = client.phone
          this.phoneForSms = client.usePhoneForSMS
          this.gender = client.gender
          this.PESEL = client.pesel
          this.emailAddress = client.emailAddress
          this.therapist = client.therapistID
          this.knowledge_of_us = client.knowledgeOfUsSource
          this.notes = client.notes
          this.street = client.street
          this.city = client.city
          this.postcode = client.postcode
          this.region = client.region
          this.have_representative = client.haveRepresentative
          this.representative_data = client.representativeData
          this.agree_receive_sms = client.patientAgreeToReceiveSMS
          this.confirm_sms = client.patientConfirmVisitsBySMS
          this.refuse_receive_email = client.patientRefuseReceivingEmails
          this.agree_process_data = client.patientAgreeToProcessHisData
          this.agree_for_commercial = client.agreeForCommercialInformations
          this.agree_for_health_services = client.agreeForHealthServices
          this.covidQuestionnaire = client.covidQuestionnaire
          this.NIP = client.nip
          this.description = client.description
          this.numer_lokalu = client.numer_lokalu
          this.numer_budynku = client.numer_budynku
          this.PayByPayU = client.payByPayU
          if (client.representativeID > 0)
            this.getClientValue(client.representativeID)
          else
            this.loading = false;
          if (client.kredyt) {
            this.kredyt = client.kredyt
            if (this.podstawy_kredytu.indexOf(client.kredyt_podstawa) > -1) {
              this.wybrana_podstawa = client.kredyt_podstawa
            }
            else {
              this.wybrana_podstawa = 'Inne'
              this.inna_podstawa_kredytu = client.kredyt_podstawa
            }

            if (client.waznosc_kredytu) {
              this.waznosc_kredytu = dayjs(client.waznosc_kredytu).format('YYYY-MM-DD')
            }
            this.limit_kredytowy = client.limit_kredytowy

          }
        } else {
          throw "Error: " + resp.data.error;
        }
      }).catch(e => {
        console.log(e);
        this.showError(true, "Nie można pobrać informacji o roli.");
        this.loading = false;
      });
    },
    loadTherapistsAndClient() {
      this.loading = true;
      userService.GetUsersWithRoles({ IsActive: true, RolesList: ['terapeuta'], ExcludeAdmin: true }).then(response => {
        if (response.data != null && response.data.result != null) {

          response.data.result.forEach(r => {
            this.therapists.push({ id: r.id, name: r.name + ' ' + r.surname });
          })
          this.loadClientData()
        }
        else {
          throw 'error pobierania terapeutów'
        }
      }).catch(() => {
        this.loading = false;
        this.showError(true, 'Nie można pobrać listy terapeutów.');
      })
    },
    getClientValue(id) {
      clientService.get(id).then(resp => {
        if (resp.data != null && resp.data.success && resp.data.result != null) {
          let item = resp.data.result;
          if (!this.representativeList.find(x => x.id === item.id)) {
            let name = item.name + " " + item.surname;
            if (item.pesel != null && item.pesel != "")
              name = name + "/" + item.pesel;
            this.representativeList.push({
              id: item.id,
              name: name,
              therapist: item.therapistID
            });
          }
          this.representativeID = id
          this.loading = false
        }
        else {
          throw 'error'
        }
      })
        .catch(() => {
          this.loading = false
          this.showError(true, 'Nie można pobrać opiekuna.');
        })
    },
    getClientValues(val) {
      this.isLoadingRepresenatives = true;
      clientService
        .getAll({ query: val, page: 1, limit: 20, sorting: "surname" })
        .then(data => {
          data.data.result.items.forEach(item => {
            if (!this.representativeList.find(x => x.id === item.id)) {
              let name = item.name + " " + item.surname;
              if (item.pesel != null && item.pesel != "")
                name = name + "/" + item.pesel;
              this.representativeList.push({
                id: item.id,
                name: name,
                therapist: item.therapistID
              });
            }
          });

          this.isLoadingRepresenatives = false;
        })
        .catch(() => {
          this.isLoadingRepresenatives = false;
          this.showError(true, "Nie można pobrać listy opiekunów.");
        });
    },
    showRepresentativeDetails() {
      if (this.representativeID > 0) {
        clientService.get(this.representativeID).then(resp => {


          if (resp.data != null && resp.data.success && resp.data.result != null) {

            let client = resp.data.result;
            this.representativeDetails = client
            this.showRepresentativeDialog = true
          }

        }).catch(() => {
          this.showError(true, "Nie można pobrać informacji o opiekunie.");
        })
      }
    },
    successSaveNewRepresentative(representative) {
      this.representativeList.push({
        id: representative.id,
        name: representative.name + " " + representative.surname,
        therapist: 0
      });
      this.representativeID = representative.id
      this.addQuickClientDialog = false
    },
    quickAddRepresentative() {
      let address = {
        street: this.street,
        city: this.city,
        postcode: this.postcode,
        region: this.region
      }
      this.addressdetails = address
      this.addQuickClientDialog = true
    },
    getAgreeTemplates() {
      settingsService.getAgreeTemplates().then(result => {
        this.agreeTemplates = result.data.result
      }).catch(() => {
        this.showError('Błąd pobierania szablonów zgód')
      })
    },
    getDescriptions() {
      clientService.getFileDescriptions().then((resp) => {
        let descr = resp.data.result
        descr.push({ description: 'Inny', type: 0 });
        this.fileDescriptions = descr
      }).catch(() => {
        this.showError('Błąd pobierania typów załączników')
      })
    },
    generateagreetemplate(type) {
      clientService.generateAgreeTemplate(this.id, type).then((result) => {
        let res = result.data.result
        let a = document.createElement("a"); //Create <a>
        a.href = "data:application/octet-stream;base64," + res.fileBase64; //Image Base64 Goes here
        a.download = res.fileName; //File name Here
        a.setAttribute('target', '_blank');
        a.click(); //Downloaded file
      }).catch(() => {
        this.showError('Błąd generowania zgody')
      })
    },
    getAttachments() {
      if (this.id > 0) {
        clientService.GetAttachments(this.id).then((resp) => {
          this.attachments = resp.data.result
          let zgodaOpiekuna = this.attachments.find(x => x.type == 5)
          let zgodaSMSEmail = this.attachments.find(x => x.type == 3)
          let processDataAtt = this.attachments.find(x => x.type == 1)
          let healthServicesAtt = this.attachments.find(x => x.type == 2)
          let commercialAtt = this.attachments.find(x => x.type == 6)
          let covidAtt = this.attachments.find(x => x.type == 4)
          if (zgodaOpiekuna) {
            this.zgodaOpiekunaPrawnego = zgodaOpiekuna
            this.enableUploadZgodaOpiekunaPrawnego = false
          }
          else {
            this.zgodaOpiekunaPrawnego = null
            this.enableUploadZgodaOpiekunaPrawnego = true
          }
          if (zgodaSMSEmail) {
            this.zgodaSmsEmail = zgodaSMSEmail
            this.enableUploadZgodaSmsEmail = false
          }
          else {
            this.zgodaSmsEmail = null
            this.enableUploadZgodaSmsEmail = true
          }
          if (processDataAtt) {
            this.processData = processDataAtt
            this.enableUploadProcessData = false
          }
          else {
            this.processData = null
            this.enableUploadProcessData = true
          }
          if (healthServicesAtt) {
            this.healthServices = healthServicesAtt
            this.enableUploadHealthServices = false
          }
          else {
            this.healthServices = null
            this.enableUploadHealthServices = true
          }
          if (commercialAtt) {
            this.commercialInformation = commercialAtt
            this.enableUploadCommercialInformation = false
          }
          else {
            this.commercialInformation = null
            this.enableUploadCommercialInformation = true
          }
          if (covidAtt) {
            this.covidQuestionnaireAttachment = covidAtt
            this.enableUploadCovidQuestionnaireAttachment = false
          }
          else {
            this.covidQuestionnaireAttachment = null
            this.enableUploadCovidQuestionnaireAttachment = true
          }
        }).catch(() => {
          this.showError('Nie można pobrać listy załączników')
        })
      }
    },
  },

  created() {
    this.loading = true;
    userService.GetUsersWithRoles({ IsActive: true, RolesList: ['terapeuta'], ExcludeAdmin: true }).then(response => {
      if (response.data != null && response.data.result != null) {

        response.data.result.forEach(r => {
          this.therapists.push({ id: r.id, name: r.name + ' ' + r.surname });
        })

      }
      else {
        throw 'error pobierania terapeutów'
      }
      if (this.id == 0) {
        this.loading = false;
      }
      else {

        this.loadClientData()
      }
    }).catch(() => {
      this.loading = false;
      this.showError(true, 'Nie można pobrać listy terapeutów.');
    })
  },
  mounted() {
    if (this.$can('do', 'POKO_Klienci_Zalaczniki_Dodawanie')) {
      this.getDescriptions()
    }
    this.getAgreeTemplates()
  },
  updated() {
  },
  computed: {
    ...mapState('featuresModule', ['features']),
    showModal: {
      get: function () {
        if (!this.visible) {
          this.clearFormData()
          this.errors.clear();
        }
        return this.visible
      },
      set: function (value) {
        if (!value) {
          this.$emit('close')
        }

      }
    },
    isAttachementsEnabled: function () {
      return this.features && this.features.ZalacznikiPoko
    },
    zgodaOpiekunaPrawnegoDescription: function () {
      return this.zgodaOpiekunaPrawnego ? this.zgodaOpiekunaPrawnego.orginal_file_name : 'Brak załącznika'
    },
    zgodaSmsEmailDescription: function () {
      return this.zgodaSmsEmail ? this.zgodaSmsEmail.orginal_file_name : 'Brak załącznika'
    },
    processDataDescription: function () {
      return this.processData ? this.processData.orginal_file_name : 'Brak załącznika'
    },
    healthServicesDescription: function () {
      return this.healthServices ? this.healthServices.orginal_file_name : 'Brak załącznika'
    },
    commercialInformationDescription: function () {
      return this.commercialInformation ? this.commercialInformation.orginal_file_name : 'Brak załącznika'
    },
    covidQuestionnaireAttachmentDescription: function () {
      return this.covidQuestionnaireAttachment ? this.covidQuestionnaireAttachment.orginal_file_name : 'Brak załącznika'
    },
    isPayuEnabled: function () {
      return this.features && this.features.PayU
    }
  },
  watch: {
    PESEL(newPesel) {
      this.setGenderFromPesel(newPesel);
      this.calculateBirthDateAndAge(newPesel);
    },
    id: function (newId) {

      if (newId > 0) {
        this.loading = true
        this.loadTherapistsAndClient()
      }
      else {
        this.clearFormData()
        this.errors.clear();
      }

    },
    representativeKeyword(val) {
      if (val) {
        this.getClientValues(val);
      }
    },
    active_tab: function (number) {
      if (number == 2) {
        this.getAttachments()
      }
    }
  }
}
</script>

<style></style>
